import { FETCH_PDF_STARTED, FETCH_PDF_DONE, FETCH_PDF_FAILED } from '../actions/actionTypes'

const initialState = {
  fetching: false,
  error: ''
}

export const fetchPdf = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PDF_STARTED: {
      return {
        ...state,
        fetching: true
      }
    }
    case FETCH_PDF_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    case FETCH_PDF_DONE: {
      return {
        ...state,        
        fetching: false,
        error: ''
      }
    }
    default:
      return state
  }
}
